import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import { ref } from '../../../../../adapter-vue';
import { decodeTextMessage } from '../../../../TUIChat/utils/emojiList';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-text',
  props: {
    content: {
      default: () => []
    },
    highlightType: {
      default: 'font'
    },
    displayType: {
      default: 'info'
    }
  },
  setup(__props) {
    var props = __props;
    var contentText = ref(props.content);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['message-abstract-text', "message-abstract-text-".concat(_ctx.highlightType), "message-abstract-text-".concat(_ctx.displayType)])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentText), (contentItem, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass([contentItem && contentItem.isHighlight ? 'highlight' : 'normal'])
        }, _toDisplayString(_unref(decodeTextMessage)(contentItem.text)), 3);
      }), 128))], 2);
    };
  }
});